import { useTaskRepeated } from "../api/queries/useTaskRepeated"
import { MultiSelect } from "primereact/multiselect"

export default function TaskRepeatedMultiFilter(props) {
  const { data: taskRepeated = [] } = useTaskRepeated()

  return (
    <MultiSelect
      showClear={true}
      filter={true}
      options={taskRepeated}
      optionLabel={"name"}
      optionValue={"value"}
      placeholder={"Opakování"}
      selectedItemsLabel={"{0} záznamů vybráno"}
      value={props.value}
      onChange={props.onChange}
    />
  )
}
